enum BrokerageFeeFormatEnum {
    Dollars = 'DOLLARS',
    Percentage = 'PERCENTAGE',
}

export default BrokerageFeeFormatEnum;
